import axios from 'axios'

var qs = require('qs');
var root = process.env.API_ROOT


export const getListData = (params) => {
  return axios.post(root + '/pay/paymain/list', qs.stringify(params))
}

//删除行
export const deleteData = (params) => {
  return axios.post(root + '/pay/paymain/remove', qs.stringify(params))
}

//获取某一行的明细数据
export const getDetail = (params) => {
  return axios.post(root + '/pay/paymain/detail', qs.stringify(params))
}

//保存某一行的数据
export const saveData = (params, flag) => {
  if (!flag) {//修改
    return axios.post(root + '/pay/paymain/update', qs.stringify(params))
  } else {
    return axios.post(root + '/pay/paymain/save', qs.stringify(params))
  }
};
//付款申请单
export const saveDataPaymain = (params, flag) => {
  if (!flag) {//修改
    return axios.post(root + '/pay/paymain/updatefukuan', qs.stringify(params))
  } else {
    return axios.post(root + '/pay/paymain/savefukuan', qs.stringify(params))
  }
}
//费用报销单
export const saveDataBaoXiao = (params, flag) => {
  if (!flag) {//修改
    return axios.post(root + '/pay/paymain/updatebaoxiao', qs.stringify(params))
  } else {
    return axios.post(root + '/pay/paymain/savebaoxiao', qs.stringify(params))
  }
}





// WEBPACK FOOTER //
// ./src/api/pay/paymain.js